import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {getCurrentAction, getCurrentScenario} from "../selectors";
import {_next, getBranch, getBranchActions, isAnyUserInputAction} from "../utils";
import {analyticsSendEvent} from "../../../libs/analytics";

export default function passAction() {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();

    const action = getCurrentAction(state);

    if (state.branchId) {
      const rootAction = getCurrentScenario(state).actions[state.index];
      const branch = getBranch(rootAction, state.branchId);

      if (branch?.__typename === "ChoiceUserInputBranch") {
        const branchActions = getBranchActions(branch);
        const nextBranchIndex = branchActions ? _next(branchActions, state.level, state.branchIndex!) : undefined;

        if (nextBranchIndex === undefined && branch.targetScenarioId) {
          dispatch({
            type: "startScenario",
            payload: {
              scenarioId: branch.targetScenarioId,
              branchId: branch.id,
            },
          });
          return;
        }
      }
    }

    if (!action || isAnyUserInputAction(action)) {
      console.warn("passAction: wrong action");
      return;
    }

    analyticsSendEvent("playerPassAction", {
      sessionId: state.sessionId!,
      actionId: action.id,
      actionType: action.__typename,
    });

    if (action.__typename === "AvatarAction" && action.id === "feedback-content") {
      dispatch({type: "finishChallenge"});
      return;
    }

    dispatch({type: "next"});
  };
}
